<template>
    <div>
        <div class="layout">
            <div class="cabinet-page_bg"></div>

            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <ClientNavigation/>
                    <div class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title">
                                <a href="#" @click="goBack" class="button-close">
                                    <BackIcon/>
                                </a>
                                <span>Оформите подписку</span>
                            </div>
                        </div>
                        <div v-if="rendered">
                            <div v-if="stage !=='success' && stage !== 'error'" class="cabinet-content-inner">

                                <div class="cabinet-text">
                                    <p>Оформите подписку для того, чтобы мы&nbsp;могли отслеживать активность Вашей платежной карты. Если списание средств прекратится, то&nbsp;мы&nbsp;попытаемся связаться с&nbsp;Вами и&nbsp;убедиться, что с&nbsp;Вами все хорошо. Стоимость подписки&nbsp;&mdash; всего 30&nbsp;рублей в&nbsp;месяц на&nbsp;одно сообщение, по&nbsp;одному рублю в&nbsp;день.</p>
                                </div>

                                <div class="cabinet-promo-text">
                                    <div class="text-item">1 письмо</div>
                                    <div class="text-item">1 день</div>
                                    <div class="text-item">1 рубль</div>
                                </div>

                                <div class="form">

                                    <div class="button-block">
                                        <button @click="confirmSubscription" class="button button-dark">Оформить подписку</button>
                                    </div>

                                </div>

                            </div>
                            <SubscriptionSuccess v-if="stage === 'success'" />
                            <SubscriptionError v-if="stage === 'error'" @confirmSubscription="confirmSubscription"/>
                        </div>
                        <div v-else>
                            <div class="cabinet-content-inner">

                                <div class="cabinet-notice-big subscribe-text-loading">
                                    <div class="icon">
                                        <div class="spinner-load"><div class="spinner"></div></div>
                                    </div>
                                    <div class="text">Подождите, ваши файлы загружаются на Google Диск</div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <FooterAuth/>
    </div>
</template>

<script>
import FooterAuth from "../components/FooterAuth";
import HeaderAuth from "../components/HeaderAuth";
import ClientNavigation from "../components/ClientNavigation";
import rest from "../restUtils";
import router from "../router";
import BackIcon from "../components/icons/BackIcon";
import SubscriptionSuccess from "../components/blocks/SubscriptionSuccess";
import SubscriptionError from "../components/blocks/SubscriptionError";

export default {
        name: "SubscriptionConfirm",
        components: {
            SubscriptionError,
            SubscriptionSuccess,
            BackIcon,
            ClientNavigation,
            HeaderAuth,
            FooterAuth,
        },
        data() {
            return {
                mailId: 0,
                stage: '',
                rendered: false,
                timer: null
            }
        },

        beforeCreate() {
            $('body').attr('class', 'cabinet-page');
        },

        async created() {
            this.mailId = this.$route.query.id;
            this.stage = this.$route.query.stage;

            if (this.$route.query.from && this.$route.query.from === 'yandex') {
                let paymentResult = await rest.doGet("/yandex/payment/" + this.mailId);
                this.stage = paymentResult ? "success" : "error";
            }
            this.rendered = true;
            if (this.stage === "success") {
                this.timer = setTimeout(function(){
                    router.push('/mails');
                }, 3000);
            }
        },
        methods: {
            goBack() {
                if (this.$route.query.returnPage) {
                    router.push({path: '/' + this.$route.query.returnPage});
                } else {
                    router.push({path: '/mail', query: {id: this.mailId}});
                }
            },
            async confirmSubscription() {
                try {
                    let location = await rest.doPost('/yandex/request?letterId=' + this.mailId);
                    if (location !== '') {
                        window.location = location;
                    } else {
                        this.stage = 'error';
                    }
                } catch (e) {
                    console.log(e);
                    this.stage = 'error';
                }
            }
        },

        beforeRouteLeave (to, from, next) {
            if (this.timer !== null) {
                clearTimeout(this.timer);
            }
            next();
        }

    }
</script>

<style scoped>

</style>